import React from 'react';
import { faCheck, faInfo } from '@fortawesome/free-solid-svg-icons';
import { ClosingDateNotice } from './ClosingDateNotice';

export interface ClosingDateGuidanceAlertProps {
    isConfirmed: boolean;
}

export const ClosingDateGuidanceAlert = ({
    isConfirmed,
}: ClosingDateGuidanceAlertProps) => (
    <ClosingDateNotice
        tone={isConfirmed ? 'success' : 'info'}
        icon={isConfirmed ? faCheck : faInfo}
        className="closing-date-guidance-alert">
        {isConfirmed
            ? 'All parties have agreed on this closing date. If circumstances change, you can still propose a new date, which will require acceptance from all parties again.'
            : 'We recommend discussing with your counsel before proposing or accepting a date, and confirming your full team can support any date you accept.'}
    </ClosingDateNotice>
);
